import type { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { CorrespondenceCard } from "@/pages/admin/dossiers/components/correspondence-card";

interface ClaimDossierCorrespondenceTabProps {
  data: Dossier | undefined;
  isLoading: boolean;
}

export const ClaimDossierCorrespondenceTab = ({
  data,
  isLoading,
}: ClaimDossierCorrespondenceTabProps) => {
  return <CorrespondenceCard dossier={data} isLoading={isLoading} />;
};
